module.exports = __webpack_public_path__ + "static/media/office1.28885c5d.jpg";